export const table = {
  row_per_page: 'Ligne par page',
};
